import { z } from 'zod';
import { tinkoffStatusSchema } from '../const/tinkoffStatusSchema';

export const tinkoffWebhookSchema = z
    .object({
        TerminalKey: z.string().min(1),
        OrderId: z.string().min(1),
        Success: z.coerce.boolean(),
        Status: tinkoffStatusSchema,
        PaymentId: z.coerce.string().optional(),
        Amount: z.coerce.number().int().nonnegative().optional(),
        ErrorCode: z.string().optional(),
        Message: z.string().optional(),
        CardId: z.coerce.number().optional(),
        Pan: z.string().optional(),
        ExpDate: z.string().length(4).optional(),
        RebillId: z.coerce.string().optional(),
        SpAccumulationId: z.string().optional(),
        DATA: z.unknown().optional(),
        Token: z.string().length(64),
    })
    .passthrough();

export type TinkoffWebhookSchema = z.infer<typeof tinkoffWebhookSchema>;
